import { Injectable } from "@angular/core";
import { XsHttpApiService } from "../../common/services/xs-http-api.service";
import { PlusdCommonService } from "../../plusd/services/plusd-common.service";

@Injectable({
  providedIn: "root"
})

export class JwtService {
  constructor(
    public xsHttpApiService: XsHttpApiService,
    public plusdCommonService: PlusdCommonService,
  ) { }

  autenticar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/security/jwt/auth",
      parametro
    );
  }
}
